function initializeDataTableSearches() {
  $('[data-table-search]').each(function() {
    var dataTable = $(this).data('table-search');
    var dataTableSelector = '[data-table=' + dataTable + ']';
    var dataTableSearchSelector = '[data-table-search=' + dataTable + ']';
    initializeCustomDataTableSearch(dataTableSelector, dataTableSearchSelector);
  });
}

$(document).ready(function(){
  initializeDataTableSearches();
});

// Re-initialize on Turbo navigation
document.addEventListener('turbo:load', function() {
  initializeDataTableSearches();
});